export const getContent = (ids, post_type, page) => {
    return fetch(`${window.location.origin}/arredamenti/wp-admin/admin-ajax.php?action=filterproducts&post_type=${post_type}&cat_ids=${ids.join()}&paged=${page}`)
    .then(response => {
        // The API call was successful!
        return response.text();
    }).then( html => {
        // This is the HTML from our response as a text string
        return html;
    }).catch(() => {
        // There was an error
        return false;
    });
}


// WEBPACK FOOTER //
// ./scripts/modules/archive-fetch.js